module.exports = __webpack_public_path__ + "img/liguangfuwu.2cd43f47.png";